import { DeviceProperty } from '@/api/device-thingmodel';
import { Form, Input, InputNumber, Modal, Radio } from 'antd';
import React, { useEffect } from 'react';

interface WriteValueModalProps {
  open: boolean;
  onCancel: () => void;
  onOk: (value: string | number | boolean) => void;
  item?: DeviceProperty;
}

export const WriteValueModal: React.FC<WriteValueModalProps> = ({ open, onCancel, onOk, item }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open && item) {
      // 根据 data_type 设置初始值
      let initialValue: any = item.value;
      const dataType = item.data_type?.toLowerCase();
      
      if (dataType === 'bool') {
        initialValue = item.value ? 'true' : 'false';
      } else if (dataType === 'int' || dataType === 'float') {
        initialValue = item.value ?? undefined;
      } else {
        initialValue = item.value ?? '';
      }
      
      form.setFieldsValue({ value: initialValue });
    } else if (!open) {
      form.resetFields();
    }
  }, [open, item, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      let convertedValue: string | number | boolean = values.value;
      
      // 根据 data_type 转换值
      if (item?.data_type === 'bool') {
        convertedValue = values.value === 'true' || values.value === true;
      } else if (item?.data_type === 'int' || item?.data_type === 'float') {
        convertedValue = values.value;
      } else {
        convertedValue = String(values.value);
      }
      
      onOk(convertedValue);
      form.resetFields();
    } catch (error) {
      console.error('Validate Failed:', error);
    }
  };

  const renderInput = () => {
    if (!item) return <Input placeholder="请输入写入值" />;

    const dataType = item.data_type?.toLowerCase();

    if (dataType === 'int') {
      return (
        <InputNumber
          style={{ width: '100%' }}
          placeholder="请输入整数"
          precision={0}
        />
      );
    }

    if (dataType === 'float') {
      return (
        <InputNumber
          style={{ width: '100%' }}
          placeholder="请输入浮点数"
          precision={10}
        />
      );
    }

    if (dataType === 'bool') {
      return (
        <Radio.Group>
          <Radio value="true">True</Radio>
          <Radio value="false">False</Radio>
        </Radio.Group>
      );
    }

    // enum 和 text 类型使用普通输入框
    return <Input placeholder="请输入写入值" />;
  };

  const getRules = () => {
    const baseRules = [{ required: true, message: '请输入写入值' }];
    
    if (!item) return baseRules;
    
    const dataType = item.data_type?.toLowerCase();
    
    if (dataType === 'int') {
      return [
        ...baseRules,
        { type: 'number' as const, message: '请输入有效的整数' },
      ];
    }
    
    if (dataType === 'float') {
      return [
        ...baseRules,
        { type: 'number' as const, message: '请输入有效的浮点数' },
      ];
    }
    
    return baseRules;
  };

  return (
    <Modal
      title="数据下发 (控制)"
      open={open}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={handleOk}
      okText="确定"
      cancelText="取消"
    >
      <Form form={form} layout="vertical">
        <Form.Item label="写入属性:">
          <Input value={item?.name || ''} disabled placeholder={item?.name || '温度'} />
        </Form.Item>
        <Form.Item 
          name="value" 
          label="*写入值:" 
          rules={getRules()}
        >
          {renderInput()}
        </Form.Item>
      </Form>
    </Modal>
  );
};
